import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { useTranslation } from "components/i18n/source";
import { Image, Link } from "components/ui/source";
import { socialLinks } from "components/ui/source/util/constants";

import styles from "./SocialLinks.module.scss";

function SocialLinks({ color }) {
  const { t } = useTranslation();

  return (
    <div className={styles.social_links}>
      {socialLinks.map(siteData => (
        <Link
          className={classnames(
            styles.social_link,
            styles[color],
            styles[`${siteData.name}_link`],
          )}
          href={t(`footer.social.${siteData.name}`)}
          key={siteData.name}
        >
          <span className="sr-only">{siteData.name}</span>
          <Image className={styles[siteData.name]} alt="" src={siteData.url} />
        </Link>
      ))}
    </div>
  );
}

SocialLinks.propTypes = {
  color: PropTypes.string,
};

SocialLinks.defaultProps = {
  color: "white",
};

export default SocialLinks;
